import React, { useMemo } from 'react'

import { ComboBox, ComboBoxChange, ComboBoxOption } from 'components/ComboBox'

import { useCompanyDetail } from '../../../hooks/useCompanyDetail'

import type { ContactMaster } from './types'

type Props = {
  id?: string
  tenantId: string | null
  warehouseId: string | null
  driverCompanyId: string | null
  value: string
  onChange: (next: ComboBoxChange) => void
  onSelectMaster?: (master: ContactMaster) => void
  isLocked?: boolean
  onClear?: () => void
  disabled?: boolean
}

export const DriverComboBox: React.FC<Props> = ({
  id,
  tenantId,
  warehouseId,
  driverCompanyId,
  value,
  onChange,
  onSelectMaster,
  isLocked,
  onClear,
  disabled,
}) => {
  const { companyDetail, isLoading } = useCompanyDetail({
    tenantId,
    warehouseId,
    companyId: driverCompanyId,
    type: 'driver',
  })

  const drivers = companyDetail?.drivers.data ?? []

  const options = useMemo<ComboBoxOption[]>(
    () =>
      drivers
        .filter((d) => d.attributes.name)
        .map((d) => ({ label: d.attributes.name as string, value: d.id })),
    [drivers]
  )

  const handleChange = (next: ComboBoxChange) => {
    onChange(next)
    if (next.value && onSelectMaster) {
      const driver = drivers.find((d) => d.id === next.value)
      if (driver) {
        onSelectMaster({
          phone: driver.attributes.cellPhone,
          email: driver.attributes.email,
        })
      }
    }
  }

  return (
    <ComboBox
      id={id}
      options={options}
      value={value}
      onChange={handleChange}
      isLocked={isLocked}
      onClear={onClear}
      disabled={disabled}
      isLoading={isLoading}
    />
  )
}
